/**
 * Returns the file extension (dot-prefixed).
 *
 * Returns the empty string if no extension exists or the filename is missing.
 */
export const getFileExtension = (
  filename: string | null | undefined,
): string => {
  if (!filename) {
    return '';
  }
  const extension = filename.split('.').pop();
  return filename === extension ? '' : `.${extension}`;
};
